<template>
	<div class="MyTable">

		<el-table :data="tableData" style="width: 100%;height: 94% !important;" @selection-change="handleSelectionChange"
			:cell-style="cellStyle" :header-cell-style="customHeaderStyle" :height="setTableHeight()">
			<el-table-column v-if="tableData!=null" type="selection"></el-table-column>

			<el-table-column :label="item.label" v-for="(item,index) in table_label" :key="index" header-align="center"
				align="center" :width="getWidth(item)" show-overflow-tooltip>

				<template slot-scope="scope">
					<div class="animated-cell" :style="{ width: getWidth(item) + 'px' }">
						<div v-if="table_label.includes('dir')">
							<span>{{ scope_row(scope.row,item.value) }}</span>
						</div>

						<div v-if="item.value !== 'dir' &&item.value !== 'img'">
							<template v-if="changguiPaGe">
								<span v-if="item.value !== 'status'" class="ellipsis"
									:style="getCellStyle(item.value, scope.row)">{{ scope_row(scope.row, item.value)}}</span>
								<el-switch v-else active-text="启用" inactive-text="禁用" v-model="scope.row.status" active-color="#13ce66"
									inactive-color="#ff4949" :active-value="1" :inactive-value="0"
									@change="SwitchStatus(scope.row)"></el-switch>
							</template>
							<!-- 水电表 -->
							<template v-else-if="name==='Intelligent_devices'">
								<div v-if="item.value ==='valve_status'">
									<span class="ellipsis" v-if="scope_row2(scope.row, item.value)=='noValveCap'" style="color:#F29900 ;">
										无阀门
									</span>
									<el-switch v-else v-model="scope.row.valve_status" active-text="开启" inactive-text="关闭"
										active-color="#13ce66" inactive-color="#ff4949" active-value="open" inactive-value="close"
										@change="SwitchStatus(scope.row)">
									</el-switch>

								</div>
								<el-button v-else-if="item.value==='history'" @click="Viewhistory(scope.row)" type="primary" plain
									size="mini">查看</el-button>
								<span class="ellipsis" v-else
									:style="{...(item.value=='status'?fontcolor(scope.row):{})}">{{ scope_row2(scope.row, item.value) }}</span>
							</template>
							<template v-else>
								<span class="ellipsis" :style="getCellStyle(item.value, scope.row)">
									{{ scope_row2(scope.row, item.value) }}{{ item.value === 'electricQuantity' ? ' %' : '' }}
								</span>
							</template>
						</div>
						<div v-else-if="scope.row.dir!='' && item.value=='dir' " style="display:flex;">
							<el-image class="imagestyle" :src="scope.row.dir" :preview-src-list="[scope.row.dir]">></el-image>
						</div>
						<div v-else-if="scope.row.img!=''  && item.value=='img' " style="display:flex;">
							<el-image class="imagestyle" :src="scope.row.img" :preview-src-list="[scope.row.img]"></el-image>
						</div>
						<span v-else-if="scope.row.dir ==''&&item.value=='dir' ">暂无图片</span>

					</div>
				</template>
			</el-table-column>
			<!-- 	<el-table-column>
				<el-switch active-text="恢复" inactive-text="禁用" v-model="scope.row.status" active-color="#13ce66"
					inactive-color="#ff4949" :active-value=1 :inactive-value=0 @change="SwitchStatus(scope.row)">
				</el-switch>
			</el-table-column> -->
			<el-table-column v-if="name == 'bills'" header-align="center" align="center" label="操作" :width="columnWidth">
				<template slot-scope="scope">

					<!-- 流动图设置 -->
					<el-button type="success" size="mini" :disabled="scope.row.pay_status=='已支付'"
						@click="BannerStatus(scope.row,'后台支付')">
						后台支付
					</el-button>

				</template>
			</el-table-column>

			<el-table-column v-if="changguicaozuo" header-align="center" align="center" label="操作" :width="columnWidth">
				<template slot-scope="scope">

					<!-- 流动图设置 -->
					<el-button v-if="name=='orders'" type="info" size="mini" @click="BannerStatus(scope.row)">
						发送提醒
					</el-button>
					<el-button v-if="name=='orders'" type="success" size="mini" :disabled="scope.row.pay_status=='已支付'"
						@click="BannerStatus(scope.row,'后台支付')">
						后台支付
					</el-button>
					<el-button v-if="name=='Metermanagement'" type="primary" plain size="mini" @click="BannerStatus(scope.row)">
						详情
					</el-button>

					<!-- 合同换房、换人 -->

					<el-button v-if="name=='contract'" type="success" size="mini" @click="Edit(scope.row,'合同换房')">合同换房</el-button>
					<el-button v-if="name=='contract'" type="primary" size="mini" @click="Edit(scope.row,'合同换人')">合同换人</el-button>
					<el-button v-if="name=='contract'" type="primary" size="mini" @click="Edit(scope.row,'合同编辑')">编辑</el-button>


					<!-- 管理员密码修改 -->
					<el-button v-if="name=='administrator'" type="primary" size="mini" @click="lockinit(scope.row)">
						修改密码
					</el-button>
					<el-button v-if="name=='administrator'" type="success" size="mini" @click="getimage(scope.row)">
						绑定公众号
					</el-button>
					<!-- 智能水电表充值 -->
					<el-button v-if="name=='Intelligent_devices'" type="success" size="mini" @click="lockinit(scope.row)">
						充值
					</el-button>

					<!-- 常规 -->
					<el-button type="primary" v-if="bianjiButtonVisible" class="typebutton" @click="Edit(scope.row)" size="mini">
						{{ bianjiReviewMode ?'审核':'编辑'}}
					</el-button>

					<!-- 重置门锁密码 -->
					<el-button v-if="name=='Lock'" type="success" size="mini" @click="lockinit(scope.row)">
						重置密码
					</el-button>

					<!-- 绑定房间 -->
					<el-button v-if="name=='Lock' || name=='Intelligent_devices'" type="primary" size="mini"
						@click="roominit(scope.row)">
						绑定房间
					</el-button>

					<el-button v-if="shanchuButtonVisible" type="danger" class="typebutton" @click="Delete(scope.row)"
						size="mini">
						删除
					</el-button>

				</template>
			</el-table-column>
		</el-table>
		<div class="pagination" v-if="name!='Intelligent_devices'">
			<el-pagination background layout="prev, pager, next" :total="total" :hide-on-single-page="total<15"
				@current-change="Currentchange" :page-size="15" :current-page="page?page:1" :pager-count='5'>
			</el-pagination>
		</div>
	</div>
</template>

<script>
	export default {
		props: [
			'tableData',
			'table_label',
			'name',
			'total',
			'page'
		],
		data() {
			return {
				tableHeight: 0,
			}
		},
		methods: {
			handleSelectionChange(val) {
				const multipleSelection = []
				// 取出 id 字段
				val.forEach(item => {
					const id = item.id
					// 判断数组中是否包含这个 id 
					if (multipleSelection.indexOf(id) == -1) {
						multipleSelection.push(`${id}`)
					}
				})
				this.$emit("BatchDeleteValue", multipleSelection)
			},
			fontcolor(value) {
				if (!value) return {}; // 安全兜底
				if (value.wxopenid != null && value.wxopenid !== '' && value.wxopenid !== '0' && value.wxopenid !== 'false' &&
					value.wxopenid !== '否') {
					return {
						color: '#1bad1a'
					};
				}
				// 绿色
				const greenStatuses = [
					'有效', '在租', '同意', '已出租', '修改成功', '正常', '在线', '通过', '已支付'
				];
				const greenFields = [{
						field: 'status',
						values: greenStatuses
					},
					{
						field: 'is_use',
						values: ['是']
					},
					{
						field: 'pay_status',
						values: ['已支付']
					},
					{
						field: 'workstatus',
						values: ['正常']
					},
					// {
					// 	field: 'wxopenid',
					// 	values: ['是', !null]
					// },
					{
						field: 'repairstatus',
						values: ['已维修']
					},
					{
						field: 'pwdType',
						values: ['长期']
					}
				];

				//  红色
				const redStatuses = ['过期', '已退租', '拒绝', '离线', '修改失败'];
				const redFields = [{
						field: 'status',
						values: redStatuses
					},
					{
						field: 'is_success',
						values: ['修改失败']
					},
					{
						field: 'repairstatus',
						values: ['待处理']
					},
					{
						field: 'pwdType',
						values: ['临时']
					}
				];

				// 橙色
				const orangeStatuses = ['未出租', '审核中', '待支付', '异常', '维修中'];
				const orangeFields = [{
						field: 'status',
						values: orangeStatuses
					},
					{
						field: 'is_use',
						values: ['否']
					},
					{
						field: 'pay_type',
						values: ['在线支付']
					},
					{
						field: 'pay_status',
						values: ['待支付']
					},
					{
						field: 'workstatus',
						values: ['异常']
					},
					{
						field: 'wxopenid',
						values: ['否', null, undefined, '', '0', 0, 'false', false]
					},
					{
						field: 'repairstatus',
						values: ['维修中']
					}
				];

				// 检查是否匹配绿色
				for (const {
						field,
						values
					}
					of greenFields) {
					if (values.includes(value[field])) {
						return {
							color: '#1bad1a'
						};
					}
				}

				// 检查是否匹配红色
				for (const {
						field,
						values
					}
					of redFields) {
					if (values.includes(value[field])) {
						return {
							color: '#eb3941'
						};
					}
				}

				// 检查是否匹配橙色
				for (const {
						field,
						values
					}
					of orangeFields) {
					if (values.includes(value[field])) {
						return {
							color: '#F29900'
						};
					}
				}

				//  默认
				return {
					color: 'inherit'
				}; // 或 '#000'
			},
			scope_row(i, v) {
				if (i.is_use === 0) {
					i.is_use = '否'
				} else if (i.is_use === 1) {
					i.is_use = '是'
				} else if (i.sex === 1) {
					i.sex = '男'
				} else if (i.sex === 2) {
					i.sex = '女'
				}
				if (v === 'wxopenid') {
					const falsy = [null, undefined, '', '0', 0, 'false', false, '否'];
					return falsy.includes(i[v]) ? '否' : '是';
				}
				if (v === 'ismsg') {
					const falsy = [null, undefined, '', '0', 0, 'false', false];
					return falsy.includes(i[v]) ? '否' : '是';
				}
				return i[v]
			},
			scope_row2(i, v) {
				if (i.status === 0) {
					i.status = '过期'
				} else if (i.status === 1) {
					i.status = '有效'
				} else if (i.type === 1 && this.name == 'contract') {
					i.type = '月度交租'
				} else if (i.type === 2 && this.name == 'contract') {
					i.type = '季度交租'
				} else if (i.type === 1 && this.name != 'contract') {
					i.type = '月度交租'
					if (i.status === '过期') {
						i.status = '审核中'
					} else if (i.status === '有效') {
						i.status = '通过'
					} else if (i.status === 2) {
						i.status = '拒绝'
					}
				} else if (i.type === 2 && this.name != 'contract') {
					i.type = '季度交租'
					if (i.status === '过期') {
						i.status = '审核中'
					} else if (i.status === '有效') {
						i.status = '通过'
					} else if (i.status === 2) {
						i.status = '拒绝'
					}
				} else if (this.name == 'surrender') {
					if (i.status === '过期') {
						i.status = '审核中'
					} else if (i.status === '有效') {
						i.status = '通过'
					} else if (i.status === 2) {
						i.status = '拒绝'
					}
				} else if (i.pay_status === 1) {
					i.pay_status = '已支付'
				} else if (i.pay_status === 0) {
					i.pay_status = '待支付'
				} else if (this.name == 'Lock') {
					if (i.status === '过期') {
						i.status = '未出租'
					} else if (i.status === '有效') {
						i.status = '已出租'
					}
				} else if (this.name === 'orders') {
					if (i.type == 1) {
						i.type = '水费'
					} else if (i.type == 2) {
						i.type = '电费'
					} else if (i.type == 3) {
						i.type = '房租'
					} else if (i.type == 4) {
						i.type = '押金差额'
					} else if (i.pay_type == 1) {
						i.pay_type = '小程序支付'
					} else if (i.pay_type == 2) {
						i.pay_type = '线下支付'
					}
				} else if (this.name == 'room') {
					if (i.status === '有效') {
						i.status = '已出租'
					} else if (i.status === '过期') {
						i.status = '未出租'
					} else if (i.publish === 0) {
						i.publish = '未发布'
					} else if (i.publish === 1) {
						i.publish = '已发布'
					}
				} else if (this.name == 'Intelligent_devices') {
					if (i.status === 'offline') {
						i.status = '离线'
					} else if (i.status === 'online') {
						i.status = '在线'
					}
				} else if (i.is_success == 1) {
					i.is_success = '修改成功'
				} else if (i.is_success == 0) {
					i.is_success = '修改失败'
				} else if (i.workstatus === 0) {
					i.workstatus = '正常'
				} else if (i.workstatus === 2) {
					i.workstatus = '异常'
				} else if (i.hasGateway === 1) {
					i.hasGateway = '是'
				} else if (i.hasGateway === 0) {
					i.hasGateway = '否'
				} else if (i.isbind != '' || i.isbind != null) {
					i.isbind = '是'
				} else if (i.isbind == '' || i.isbind == null) {
					i.isbind = '否'
				}
				return i[v]
			},
			//设置单元格 wxopenid
			cellStyle({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				return 'height:40px!important; border-color:#f2f3f5!important; color:#000000!important; padding:0px!important;border-width: 2px !important;'
			},
			customHeaderStyle({
				column
			}) {},
			// 状态开关
			SwitchStatus(value) {
				// console.log('SwitchStatus', value);

				this.$confirm('是否确认此操作, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					this.$emit('SwitchStatus', value)
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});

			},
			// 点击编辑
			Edit(value, title) {
				console.log('bianji:', value);
				this.$emit("Edit", value, title)
			},
			// 点击删除
			Delete(value) {
				this.$confirm('此操作将永久删除该选项, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					this.$emit("Delete", value)
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});

			},
			// 分页事件
			Currentchange(value) {
				this.$emit("Currentchange", value)
			},
			// 动态宽度
			getWidth(item) {
				if (this.name === 'user' || this.name === 'contract' || this.name === 'Intelligent_ViewHistory' ||
					this.name === 'operation_log') {
					switch (item.label) {
						case 'ID':
							return 40;
						case '姓名':
							return 80;
						case '房间编号':
							return 80;
						case '身份证号':
							return 180;
						case '电话':
							return 180;
						case '当前剩余':
							return 80;
						case '当前累计':
							return 80;
						case '当前读数':
							return 80;
						case '绑定小程序':
							return 80;
						case '绑定公众号':
							return 80;
						case '详情':
							return 440;
						case '操作时间':
							return 200;

						default:
							return '';
					}
				} else {
					// 默认宽度或其他情况下的宽度设置
					return '';
				}
			},
			BannerStatus(value, name) {
				if (name == '后台支付') {
					this.$confirm(`确定给${value.room_num}的${value.type}进行后台支付吗？`, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
						center: true
					}).then(() => {
						this.$emit("BannerStatus", value, name)

					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});
					});
				} else {
					this.$emit("BannerStatus", value)
				}

			},
			lockinit(value) {
				this.$emit("lockinit", value)
			},
			// 绑定公众号
			getimage(value) {
				this.$emit("getimage", value)
			},
			//历史查看
			Viewhistory(value) {
				this.$emit("ViewHistory", value)
			},
			// 绑定房间
			roominit(value) {
				this.$emit("roominit", value)
			},
			// 动态文字颜色
			getCellStyle(itemValue, row) {
				if (this.name == 'Lock') {
					if (itemValue == 'status') {
						if (row.status == '未出租') {
							return {
								color: "#F29900"
							}
						} else {
							return {
								color: "#1bad1a"
							}
						}
					}
				}

				const specialFields = ['status', 'pay_status', 'is_success', 'workstatus', 'is_use', 'wxopenid',
					'repairstatus',
				];
				console.log(`是不是wxopenid：${itemValue}`, specialFields.includes(itemValue), row);
				if (specialFields.includes(itemValue)) {
					return this.fontcolor(row);
				}
				if (itemValue == 'openid') {
					if (row.openid == '否') {
						return {
							color: "#F29900"
						}
					} else {
						return {
							color: "#1bad1a"
						}
					}
				}
				if (itemValue == 'day') {
					if (row.day <= 30) {
						return {
							color: "#F29900"
						}
					} else {
						return {
							color: "#1bad1a"
						}
					}
				}
				if (itemValue == 'publish') {
					if (row.publish == '未发布') {
						return {
							color: "#F29900"
						}
					} else {
						return {
							color: "#1bad1a"
						}
					}
				}
				if (itemValue == 'ismsg') {
					if (row.ismsg == '0') {
						return {
							color: "#F29900"
						}
					} else {
						return {
							color: "#1bad1a"
						}
					}
				}
				return {};
			},
			setTableHeight() {
				this.tableHeight = window.innerHeight * 0.66;
				console.log('tableHeight:', this.tableHeight);
				return (this.tableHeight)
			}
		},
		computed: {
			columnWidth() {
				if (this.name === 'Lock') {
					return 260;
				} else if (this.name === 'orders') {
					return 340;
				} else if (this.name === 'administrator') {
					return 340;
				} else if (this.name === 'contract') {
					return 340;
				} else {
					return 172;
				}
			},
			changguiPaGe() {
				return ['kinds', 'coupon', 'user', 'repair', 'administrator'].includes(this.name);
			},
			bianjiButtonVisible() {
				return !['entry', 'password', 'Intelligent_devices', 'contract'].includes(this.name);
			},
			bianjiReviewMode() {
				return ['renew', 'surrender'].includes(this.name);
			},
			shanchuButtonVisible() {
				return !['parameters', 'terms', 'Metermanagement', 'Lock', 'Intelligent_devices'].includes(this.name);
			},
			changguicaozuo() {
				return !['bills', 'devicelist', 'Intelligent_ViewHistory', 'operation_log'].includes(this.name);
			}
		},
		mounted() {
			this.setTableHeight();
			window.addEventListener('resize', this.setTableHeight);
			console.log('win');
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.setTableHeight);
		},
	}
</script>

<style scoped>
	>>>.el-table__empty-block {
		width: 100% !important;
	}

	>>>.el-table th.el-table__cell>.cell {
		display: inline-block;
		box-sizing: border-box;
		position: relative;
		vertical-align: middle;
		padding-left: 0px;
		padding-right: 0px;
		width: 100%;
		white-space: nowrap;
		margin: 0;
		text-align: center;
	}

	>>>.el-table-column--selection .cell {
		display: inline-block;
		box-sizing: border-box;
		position: relative;
		vertical-align: middle;
		padding-left: 0px;
		padding-right: 0px;
		width: 100%;
		white-space: nowrap;
		margin: 0;
		text-align: center;
	}

	.pagination {
		background-color: #fff;
		width: auto;
		display: flex;
		justify-content: center;
		margin: 0.25rem 0;
	}

	.ellipsis {
		width: auto;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		display: block;

	}

	.imagestyle {
		height: 2.26rem;
		margin: auto;
	}

	::v-deep .el-table tr .el-table__cell .cell {
		width: 100% !important;

	}

	@media screen and (min-width: 0px) and (max-width: 1919px) {
		>>>.el-switch__label {
			display: none;
		}
	}
</style>
<style>

</style>